export default __webpack_public_path__ + "static/media/create_agent.bdec7745.svg";